$(document).ready(function () {
  $('[data-tab-btn]').click(function(event){
    event.preventDefault();
    var content_to_show = $(this).attr('data-tab-btn');
    $('[data-tab-btn]').removeClass('active');
    $(this).addClass('active');
    $('[data-tab-content]').removeClass('active');
    $('[data-tab-content=\"'+content_to_show+'\"]').addClass('active');
  });

  var currentToggleText = null,
    currentTarget = null,
    toggle = $('.filter-options > span'),
    options = $('.filter-drop-options');
  $('.js-filter-drop-options a').click(function(event){
    event.preventDefault();
    var text = $(this).text(),
      target = $(this).attr('data-filter-show');

    currentToggleText = toggle.text();
    currentTarget = toggle.attr('data-filter-show');

    toggle.text(text);
    toggle.attr('data-filter-show', target);

    if (options.data('multiple-select')) {
      $('.' + currentTarget).toggleClass('item-shown');
      $('.' + target).toggleClass('item-shown');
    }
    else {
      $('#' + currentTarget).toggleClass('dc-shown');
      $('#' + target).toggleClass('dc-shown');
    }

    options.removeClass('dc-shown');
    $(this).text(currentToggleText);
    $(this).attr('data-filter-show', currentTarget);
  });

  function hideOptions(){
    options.removeClass('dc-shown');
    unBindRemove();
  }

  function bindRemove(){
    $(document).bind('click',hideOptions);
  }
  function unBindRemove(){
    $(document).unbind('click',hideOptions);
  }

  toggle.click(function(event){
    event.preventDefault();
    event.stopPropagation();
    options.toggleClass('dc-shown');
    options.hasClass('dc-shown') ? bindRemove() : unbindRemove();
  });

  function warnOnMissingDataAttr($elem, attr) {
    if ( typeof $elem.data(attr) == 'undefined' ) {
      console.error("data-" + attr + " attribute is not defined on " + $elem);
      return
    }
  }

  // Banner can be dismissed by clicking close, which sets a cookie so we know
  // not to show it again.
  $(document.body).on('click', '.js-dismiss-home-ad', function(e) {
    e.preventDefault();
    var $btn = $(this);
    warnOnMissingDataAttr($btn, 'cookie');
    warnOnMissingDataAttr($btn, 'cookie-expires');

    var cookieName = $btn.data('cookie');
    var expiresEpoch = $btn.data('cookie-expires');
    var expirationTime = new Date(expiresEpoch);
    Cookies.set(cookieName, '1', { expires: expirationTime });
    $('.js-home-ad-' + cookieName).hide();
    $('.js-home-ad-' + cookieName).remove();

    if($btn.hasClass("js-refresh-carousel")) {
      // Refresh the carousel after removing an element from it
      $('.js-hover-carousel').each(function () {
        $(this).carousel();
      });
    }
  });

  var streakContainer = $('.home__practice-pools .gauge-container')
  if(streakContainer.length) {
    new StreakGauge(streakContainer).setAnimated();
  }

  var practicePoolToggleIcon = $('.home__practice-pools__toggle-icon-container');
  var practicePoolToggleIconSee = $('.home__practice-pools__toggle-icon__see');
  var practicePoolToggleIconClose = $('.home__practice-pools__toggle-icon__close');
  var practicePoolToggleIconSeeLabel = $('.home__practice-pools__toggle-icon__label--see');
  var practicePoolToggleIconCloseLabel = $('.home__practice-pools__toggle-icon__label--close');
  var practicePoolToggleAdditionalBlocks = $('.home__practice-pools__blocks .col-md-3:nth-child(n+4)');
  if (practicePoolToggleIcon.length) {
    practicePoolToggleIcon.click(function(){
      practicePoolToggleIconSee.toggle();
      practicePoolToggleIconClose.toggle();
      practicePoolToggleIconSeeLabel.toggle();
      practicePoolToggleIconCloseLabel.toggle();
      practicePoolToggleAdditionalBlocks.toggle();
    });
  }

  var countryCodes = $('.js-country-codes');
  var countryCode = $('.js-country-code');
  countryCodes.change(function() {
    countryCode.text($(this).find(":selected").val());
  });

  var phoneNumber = $('.js-phone-number');
  var phoneNumberError = $('.js-phone-number-error');
  phoneNumber.click(function() {
    if (phoneNumberError.length) {
      phoneNumberError.addClass('u-hidden');
    }
  });

  function reloadCourseList(link) {
    active_tab = link.data('courseType');
    $.ajax({
      type: 'GET',
      url: link.attr('href'),
      data: {
        course_type: active_tab
      }
    }).done(function(content) {
      $('#' + active_tab).html(content);
      attachCourseListLink('#' + active_tab);
    });
  }

  function attachCourseListLink(current_tab) {
    $((current_tab || '') + ' .see-toggle a').click(function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      reloadCourseList($(this));
    })
  }

  document.addEventListener("js-home-courses-loaded", function() {
    attachCourseListLink();
  })
  attachCourseListLink();
});
